import { useCallback } from 'react';
import { PrimaryButton, Spinner, Stack, TextField } from '@fluentui/react';
import { ContentSection } from '../../../../components/LayoutElements';
import { ApiCalls } from '../../../../api/api';
import { useMutation, useQuery } from '@tanstack/react-query';
import { POWERHUB_SERVICE_PRINCIPAL } from '../../../../constants/queryKeys';
import { useSetQueryData } from '../../../../hooks/useSetQueryData';

const queryKey = [POWERHUB_SERVICE_PRINCIPAL];

export function PowerHubSettings() {
    const { data: clientId, isLoading } = useQuery({
        queryKey,
        queryFn: () => ApiCalls.integrationPowerhubGetPowerhubServicePrincipalList().then(res => res.data.principalName),
    });
    const setClientId = useSetQueryData<typeof clientId>(queryKey);

    const { mutate, isLoading: updating } = useMutation(() => ApiCalls.integrationPowerhubUpsertPowerhubServicePrincipalCreate({ clientId }));
    const updateServicePrincipal = useCallback(() => {
        mutate();
    }, [mutate]);

    if (isLoading) {
        return <Spinner />;
    }

    return (
        <ContentSection>
            <Stack tokens={{ childrenGap: 32 }}>
                <TextField
                    defaultValue={clientId}
                    onChange={(e, v) => setClientId(v)}
                    styles={{ root: { alignSelf: 'center', minWidth: 300 } }}
                    label="PowerHub ClientID"
                ></TextField>
                <PrimaryButton
                    styles={{ root: { alignSelf: 'center' }, flexContainer: { minWidth: 250 } }}
                    onClick={updateServicePrincipal}
                    text={updating ? 'updating PowerHub ClientID' : 'Save PowerHub ClientID'}
                    disabled={updating}
                />
            </Stack>
        </ContentSection>
    );
}
